import FormSelectShippingReturnPartner from './components';

export default FormSelectShippingReturnPartner;
